import {Injectable, inject} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterStateSnapshot, TitleStrategy} from '@angular/router';

const DEFAULT_PAGE_TITLE = 'Tapestry';

/**
 * A custom Angular TitleStrategy that handles setting the browser tab title.
 * It prepends a global application title (if available via router data)
 * to the specific route title, falling back to a default title if no title is found.
 *
 * It looks for two potential titles:
 * 1. The specific route title, derived from the standard `TitleStrategy.buildTitle(routerState)`.
 * 2. An application-wide prefix title, found at `routerState.root.firstChild.data.appTitle`.
 *
 * The final format is typically: `[App Title] | [Route Title]` or just `[Route Title]`.
 */
@Injectable({providedIn: 'root'})
export class AppTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title) {
      const appTitle = routerState.root.firstChild?.data?.appTitle;
      this.title.setTitle(
        typeof appTitle === 'string' && appTitle && appTitle !== title
          ? `${appTitle} | ${title}`
          : title,
      );
    } else {
      this.title.setTitle(DEFAULT_PAGE_TITLE);
    }
  }
}
